import React from "react";
import {
  Container,
  Grid,
  CardActionArea,
  Card,
  CardMedia,
  CardActions,
  Typography,
  Button,
  CardContent,
  CircularProgress,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Fade from "react-reveal/Fade";
import { blogs } from "./BlogData";
import styles from "./Blog.module.css";
const useStyles = makeStyles({
  root: {
    maxWidth: "100%",
    marginTop: 20,
  },
  media: {
    height: 300,
  },
  footer: {
    justifyContent: "space-between",
  },
});
const Blogs = () => {
  const classes = useStyles();
  return (
    <Container fixed>
      <Grid
        container
        spacing={4}
        direction="row"
        justify="center"
        alignItems="center"
      >
        {blogs.map((pr) => (
          <Grid item lg={4} xs={9} md={3}>
            <Fade appear={true} spy={true} left>
              <Card className={classes.root}>
                <CardActionArea>
                  <CardMedia
                    className={classes.media}
                    image={pr.image}
                    title="Contemplative Reptile"
                  />
                  <CardContent style={{ backgroundColor: "#f4f7fa" }}>
                    <Typography
                      gutterBottom
                      variant="h5"
                      component="h2"
                      className={styles.txt}
                      style={{ fontSize: "1.8rem" }}
                    >
                      {pr.name}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      component="p"
                      className={styles.txt}
                      style={{ fontSize: "1rem" }}
                    >
                      {pr.description}
                    </Typography>
                  </CardContent>

                  <CardActions
                    style={{ backgroundColor: "#f4f7fa" }}
                    className={classes.footer}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "10px",
                      }}
                    >
                      <div className={styles.technology}>
                        {pr.technology.map((tech) => (
                          <span>{tech}</span>
                        ))}
                      </div>
                    </div>
                    <Typography
                      gutterBottom
                      variant="h5"
                      component="h2"
                      className={styles.txt}
                      style={{ fontSize: "1.2rem", marginTop: "20px" }}
                    >
                      {pr.date}
                    </Typography>
                  </CardActions>
                </CardActionArea>
              </Card>
            </Fade>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Blogs;
